import React from "react";

export function CustomizationTextsSection({ customization, handleChange, styles }) {
  return (
    <div style={styles.section}>
      <h3 style={styles.sectionTitle}>Textos</h3>

      <div style={styles.formGroup}>
        <label style={styles.label}>
          Texto do Cabeçalho:
          <input
            type="text"
            name="headerText"
            value={customization.headerText}
            onChange={handleChange}
            style={styles.input}
          />
        </label>
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>
          Mensagem de Boas-Vindas:
          <textarea
            name="welcomeMessage"
            value={customization.welcomeMessage}
            onChange={handleChange}
            style={styles.textarea}
            rows={3}
          />
        </label>
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>
          Texto do Rodapé:
          <input
            type="text"
            name="footerText"
            value={customization.footerText}
            onChange={handleChange}
            style={styles.input}
          />
        </label>
      </div>
    </div>
  );
}
